import { createAsyncThunk } from '@reduxjs/toolkit';

function getAccountInvitations(_, { extra: { http } }) {
  return http.get(`/account_invitations`);
}
function getAccountInvitationsNew(_, { extra: { http } }) {
  return http.get(`/account_invitations/new`);
}
function postAccountInvitations({ account_invitation }, { extra: { http } }) {
  return http.post(`/account_invitations`, { account_invitation });
}
function deleteAccountInvitation({ id }, { extra: { http } }) {
  return http.delete(`/account_invitations/${id}`);
}

export const indexAccountInvitations = createAsyncThunk(
  'account_invitations/index',
  getAccountInvitations
);
export const newAccountInvitation = createAsyncThunk(
  'account_invitations/new',
  getAccountInvitationsNew
);
export const createAccountInvitation = createAsyncThunk(
  'account_invitations/create',
  postAccountInvitations
);
export const destroyAccountInvitation = createAsyncThunk(
  'account_invitations/destroy',
  deleteAccountInvitation
);
